/* Component in ShotListPage to display the data for each Shot
 * Contains the ShotInfo and ShotImage components
 * Contains the ShotListEdit component */
import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../../../styles/ScheduleCreate.module.css";
import btnStyles from "../../../styles/Button.module.css";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import { Button } from "react-bootstrap";
import { PostDropdown } from "../../../components/PostDropdown";
import ShotInfo from "./ShotInfo";
import ShotImage from "./ShotImage";
import ShotListEdit from "./ShotListEdit";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import { toast } from "react-hot-toast";

const Shot = (props) => {
  const currentUser = useCurrentUser();
  const host = useHostName();
  const [showInfo, setShowInfo] = useState(false);
  const [showImg, setShowImg] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);

  const [shotNew, setShotNew] = useState({
    actors: "",
    angle: "",
    audio: "",
    camera: "",
    day_night: "",
    description: "",
    equipment: "",
    focus_pulls: "",
    frame_rate: "",
    framing: "",
    fx: "",
    id: "",
    image: "",
    int_ext: "",
    lens: "",
    lighting: "",
    location: "",
    movement: "",
    notes: "",
    order_number: "",
    scene_id: "",
    scene_number: "",
    script_ref: "",
    shot_number: "",
    size: "",
    storyboard_refs: "",
  });

  const { shotAll, handleMount, setAddShot, style } = props;
  const {
    actors,
    angle,
    audio,
    camera,
    day_night,
    description,
    equipment,
    focus_pulls,
    frame_rate,
    framing,
    fx,
    id,
    image,
    int_ext,
    lens,
    lighting,
    location,
    movement,
    notes,
    order_number,
    scene_id,
    scene_number,
    script_ref,
    shot_number,
    size,
    storyboard_refs,
  } = shotAll;

  useEffect(() => {
    if (!shotAll) return;
    setShotNew({
      id,
      scene_id,
      scene_number,
      shot_number,
      size,
      angle,
      movement,
      camera,
      lens,
      script_ref,
      storyboard_refs,
      description,
      equipment,
      fx,
      focus_pulls,
      lighting,
      audio,
      image,
      framing,
      int_ext,
      day_night,
      frame_rate,
      location,
      actors,
      notes,
      order_number,
    });
  }, [shotAll]);

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/shotlists/${id}/`);
        handleMount();
        toast.success(`Shot Deleted`);
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/shotlists/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        toast.success(`Shot Deleted Successfully!`);
        handleMount();
      }
    } catch (err) {
      // console.log(err);
    }
  };

  return (
    <div style={style} className={`${styles.Bold}`}>
      {/* medium*/}
      <div className="d-none d-md-block">
        <Row className="py-2 text-center mx-0">
          <Col className={`pl-2 ${styles.TitleBox2}`} xs={1} md={1}>
            <Button
              onClick={() => setShowInfo((showInfo) => !showInfo)}
              className={`${btnStyles.Button} ${btnStyles.Shed}`}
            >
              Info
            </Button>
          </Col>
          <Col className={`${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">{order_number + 1}</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">{size}</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">{framing}</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={4} md={4}>
            <p className="mb-0">{description}</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">{angle} </p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p>{movement}</p>
          </Col>
          {/* <Col className={`px-0 ${styles.TitleBox2}`} 
          xs={(currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin" ) ? 1 : 2}
          md={(currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin" ) ? 1 : 2}
          > */}
          <Col className={`px-0 ${styles.TitleBox2}`}
            xs={(currentUser?.groups[0]?.name === "Superadmin") ? 1 : 2}
            md={(currentUser?.groups[0]?.name === "Superadmin") ? 1 : 2}
          >
            <Button
              onClick={() => setShowImg((showImg) => !showImg)}
              className={`${btnStyles.Button} ${btnStyles.Shed}`}
            >
              Image
            </Button>
          </Col>
          {/* edit */}
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") && (
              <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
                <PostDropdown
                  handleEdit={() => setShowEditForm(true)}
                  handleDelete={handleDelete}
                />
              </Col>)}
        </Row>
      </div>
      {/* mobile*/}
      <div className="d-block d-md-none">
        <Row className="py-2 text-center mx-0">
          <Col className={`px-0 mx-0 ${styles.TitleBox2} `} xs={1} md={1}>
            <Button
              onClick={() => setShowInfo((showInfo) => !showInfo)}
              className={`pr-2 ${btnStyles.Button} ${btnStyles.Shed}`}
            >
              I
            </Button>
          </Col>
          <Col className={`${styles.TitleBox2} px-0 mx-0`} xs={1} md={1}>
            <p className="mb-0">{order_number + 1}</p>
          </Col>
          <Col className={`px-0 mx-0 ${styles.TitleBox2}`} xs={2} md={2}>
            <p className={`${styles.Para2}`}>{size}</p>
            <p className={`${styles.Para2}`}>{framing}</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`}
            xs={(currentUser?.groups[0]?.name === "Superadmin") ? 4 : 5}
            md={(currentUser?.groups[0]?.name === "Superadmin") ? 4 : 5}
          >
            <p className="mb-0">{description}</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={3} md={3}>
            <p className={`${styles.Para2}`} >{angle} </p>
            <p className={`${styles.Para2}`} >{movement} </p>
          </Col>
          {/* edit */}
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") && (
              <Col className={`px-0 mx-0 ${styles.TitleBox2}`} xs={1} md={1}>
                <div>
                  <PostDropdown
                    handleEdit={() => setShowEditForm(true)}
                    handleDelete={handleDelete}
                  />
                </div>
              </Col>
            )}
        </Row>
      </div>
      <Row>
        <Col>{!showInfo ? "" : <ShotInfo {...shotNew} />}</Col>
      </Row>
      <Row>
        <Col>{!showImg ? "" : <ShotImage image={image} />}</Col>
      </Row>
      <Row>
        <Col>
          {showEditForm ? (
            <ShotListEdit
              shotNew={shotNew}
              shot_number={shot_number}
              setShotNew={setShotNew}
              setAddShot={setAddShot}
              id={id}
              handleMount={handleMount}
              setShowEditForm={setShowEditForm}
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Shot;
